import { createTheme } from '@material-ui/core/styles';
import {colors} from '@material-ui/core';

export const Theme = createTheme({
  palette: {
    primary: colors.teal,
    secondary: colors.pink,
  },
});